export const LIVE_CHAT_FORM_URL = (transactionId: number) =>
  `/help/for_transaction/${transactionId}/live_chat`
export const NEW_HELP_TICKET_URL = '/help/support_tickets/new'
export const TRENDSALES_PAYOUT_FORM_URL = '/help/trendsales_payout'
export const NEW_COMPLAINTS_URL = '/complaints/new'
export const COMPLAINT_CREATION_URL = '/complaints/report'
export const HELP_SEARCH_URL = '/help/s'
export const APP_FEEDBACKS_URL = '/app_feedbacks'
